import React, { useState } from "react";
import Icon from "@/components/ui/Icon";
import SwitchDark from "./Tools/SwitchDark";
import HorizentalMenu from "./Tools/HorizentalMenu";
import useWidth from "@/hooks/useWidth";
import useSidebar from "@/hooks/useSidebar";
import useNavbarType from "@/hooks/useNavbarType";
import useMenulayout from "@/hooks/useMenulayout";
import useSkin from "@/hooks/useSkin";
import Logo from "./Tools/Logo";
import SearchModal from "./Tools/SearchModal";
import Profile from "./Tools/Profile";
import Notification from "./Tools/Notification";
import Message from "./Tools/Message";
import Language from "./Tools/Language";
import useRtl from "@/hooks/useRtl";
import MonoChrome from "./Tools/MonoChrome";
import HeaderCart from "./Tools/cart";
import { Link } from "react-router-dom";
import MobileLogo from "@/assets/images/logo/logosway.png";
import { LuSearch } from "react-icons/lu";
import { Tooltip, message } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import apiClient from "@/server/server";

const Header = () => {
  const [collapsed, setMenuCollapsed] = useSidebar();
  const { width, breakpoints } = useWidth();
  const [syncing, setSyncing] = useState(false);

  // Re-index profiles in Meilisearch
  const handleSyncProfiles = async () => {
    try {
      setSyncing(true);
      await apiClient.post('/meilisearch/sync/profiles');
      message.success('Profiles re-indexed successfully!');
    } catch (error) {
      console.error('Sync error:', error);
      message.error('Failed to re-index profiles');
    } finally {
      setSyncing(false);
    }
  };
  const [navbarType] = useNavbarType();
  const navbarTypeClass = () => {
    switch (navbarType) {
      case "floating":
        return "floating has-sticky-header";
      case "sticky":
        return "fixed top-0 left-[80px] right-0 z-[999]"; // Fixed for 80px sidebar
      case "static":
        return "static";
      case "hidden":
        return "hidden";
      default:
        return "fixed top-0 left-[80px] right-0 z-[999]"; // Always account for sidebar
    }
  };
  const [menuType] = useMenulayout();
  const [skin] = useSkin();
  const [isRtl] = useRtl();


  const borderSwicthClass = () => {
    if (skin === "bordered" && navbarType !== "floating") {
      return "border-b border-slate-200 dark:border-slate-700";
    } else if (skin === "bordered" && navbarType === "floating") {
      return "border border-slate-200 dark:border-slate-700";
    } else {
      return "dark:border-b dark:border-slate-700 dark:border-opacity-60";
    }
  };
  return (
    <header className={navbarTypeClass()}>
      <div
        className={`app-header px-6 h-16 dark:bg-slate-900/80 bg-white/80 backdrop-blur-xl shadow-lg border-b border-slate-200/30 dark:border-slate-700/30
        ${borderSwicthClass()}
             ${
               menuType === "horizontal" && width > breakpoints.xl
                 ? "py-1"
                 : "md:py-6 py-3"
             }
        `}
      >
        <div className="flex justify-center items-center h-full relative">
          {/* Centered Logo for both Vertical and Horizontal */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            {menuType === "vertical" ? (
              <Link to="/dashboard" className="flex items-center space-x-3">
                <img 
                  src={MobileLogo} 
                  alt="" 
                  className="h-7 w-auto"
                  style={{ maxHeight: '28px', width: 'auto' }}
                />
                <span className="text-xl font-bold text-slate-900 dark:text-white">
                  mysway.
                </span>
              </Link>
            ) : (
              <Logo />
            )}
          </div>

          {/*  Horizontal  Main Menu */}
          {menuType === "horizontal" && (
            <div className="absolute left-0">
              <HorizentalMenu />
            </div>
          )}
          
          {/* Nav Tools - Right Side */}
          <div className="absolute right-0 nav-tools flex items-center lg:space-x-6 space-x-3 rtl:space-x-reverse">
            {/* <Language />
            <SwitchDark />
            <MonoChrome />
            <HeaderCart /> */}
            {/* {width >= breakpoints.md && <Message />} */}
            {width >= breakpoints.md && (
              <Tooltip title="Re-index Profiles (Meilisearch)">
                <button
                  onClick={handleSyncProfiles}
                  disabled={syncing}
                  className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                >
                  <SyncOutlined
                    spin={syncing}
                    className={`text-lg ${syncing ? 'text-blue-500' : 'text-slate-500 dark:text-slate-400'}`}
                  />
                </button>
              </Tooltip>
            )}
            {width >= breakpoints.md && <Notification />}
            {width >= breakpoints.md && <Profile />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
